const SubAbas = [
  { label: 'Meus Dados', rota: '/daf/meusdados/usuario' },
  { label: 'Meus Acessos', rota: '/daf/meusdados/acessos' },
  { label: 'Meus Logs', rota: '/daf/meusdados/logs' },
  /*{ label: 'Relatórios Gerados', rota: '/daf/meusdados/relatorios' },*/
];

export default SubAbas;
